export enum Bidder {
  aol = 'aol',
  audienceNetwork = 'audienceNetwork',
  appnexus = 'appnexus',
  appnexusAst = 'appnexusAst',
  criteo = 'criteo',
  emx = 'emx_digital',
  google = 'google',
  gumgum = 'gumgum',
  gumgum_icv = 'gumgum_icv',
  indexExchange = 'indexExchange',
  openx = 'openx',
  pubmatic = 'pubmatic',
  roundel = 'roundel',
  rubicon = 'rubicon',
  triplelift = 'triplelift',
  uam = 'amazon',
  yieldmo = 'yieldmo',
  S2S = 'S2S'
}

export enum OutstreamBidder {
  gumgum_icv = 'gumgum_icv'
}

export enum VideoBidder {
  appnexus = 'appnexus',
  emx = 'emx_digital',
  indexExchange = 'ixVideo',
  oneVideo = 'oneVideo',
  openx = 'openx',
  pubmatic = 'pubmatic',
  pulsepoint = 'pulsepoint',
  rubicon = 'rubicon',
  roundel = 'roundel'
}
